import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "../Form";
export var SelectTableRowRadio = observer(function (_a) {
    var id = _a.id, label = _a.label, name = _a.name;
    var values = useFormContext().values;
    var handleChange = useCallback(function (e) { return values.set(name, id); }, [values, name, id]);
    return (React.createElement("label", null,
        React.createElement("input", { name: id, type: "radio", onChange: handleChange, checked: values.get(name) === id }),
        React.createElement("span", { className: "sr-only" }, label)));
});
